function validateIsUppercase(value: string) {
  return value !== value.toLowerCase() && value === value.toUpperCase();
}

export function validateHasUppercaseCharacters(value: string) {
  return value && [...value].some(char => validateIsUppercase(char));
}
